import React, { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box, FormDialog, Grid, InputField } from '@kis-technologies/kis-ui';
import { useActions } from 'hooks/useActions';
import { actions as clientsActions, selectors as clientsSelectors, CreateClientPayload } from 'store/clients';
import { doesFormHaveEmptyValue, doesFormHaveError, onInputBlur, onValueChange } from 'utils/forms';
import { useStyles } from '../styled';
import { CreateCustomerOverlayProps, CustomerForm } from '../types';
import { customerSchema, getCustomerForm } from '../utils';

const CreateCustomerOverlay = (props: CreateCustomerOverlayProps) => {
  const { onClose } = props;

  const { createClient } = useActions({
    createClient: clientsActions.createClient
  });

  const pending = useSelector(clientsSelectors.selectPending);

  const initialForm = useMemo(() => getCustomerForm(), []);
  const [form, setForm] = useState<CustomerForm>(initialForm);

  const hasEmptyValue = useMemo(() => doesFormHaveEmptyValue(form), [form]);
  const hasError = useMemo(() => doesFormHaveError(form), [form]);
  const isButtonDisabled = useMemo(() => hasEmptyValue || hasError, [hasEmptyValue, hasError]);

  const classes = useStyles();

  const onCreateClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const payload: CreateClientPayload = {
      name: form.name.value
    };
    createClient(payload);
  };

  return (
    <FormDialog
      cancelButtonAction={onClose}
      cancelButtonText="Cancel"
      confirmButtonAction={onCreateClick}
      confirmButtonDisabled={isButtonDisabled}
      confirmButtonIsLoading={pending}
      confirmButtonText="Create"
      open
      title="Create Customer"
    >
      <Grid className={classes.overlayInnerContainer}>
        {/* INPUT - NAME */}
        <Box className={classes.overlayFieldBox}>
          <InputField
            data-testid="name-input-field"
            error={form.name.error !== null}
            fullWidth
            helperText={form.name.error}
            label="Name"
            onBlur={(e) => onInputBlur(e, 'name', customerSchema, setForm)}
            onChange={(e) => onValueChange(e.target.value, 'name', setForm)}
            size="small"
            value={form.name.value}
          />
        </Box>
      </Grid>
    </FormDialog>
  );
};

export default CreateCustomerOverlay;
